import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function MembershipSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Redirect to membership page with session_id for polling
    if (sessionId) {
      navigate(`/membership?session_id=${sessionId}`, { replace: true });
    } else {
      navigate('/membership', { replace: true });
    }
  }, [sessionId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-teal-600 mx-auto mb-3" />
        <p className="text-gray-600 text-sm">Verifying your payment...</p>
      </div>
    </div>
  );
}
